import PropTypes from 'prop-types'

export const FormInput = ({
  id,
  name,
  label,
  type = 'text',
  value,
  onChange,
  onBlur,
  placeholder,
  required = false,
  disabled = false,
  autoComplete,
  error,
  helperText,
  leftIcon,
  rightIcon,
  showRequiredIndicator = true,
}) => (
  <div>
    {label && (
      <label htmlFor={id} className="block text-sm font-medium text-gray-400 mb-2">
        {label}
        {required && showRequiredIndicator && <span className="text-red-400 ml-1">*</span>}
      </label>
    )}
    <div className="relative">
      {leftIcon && (
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
          {leftIcon}
        </div>
      )}
      <input
        id={id}
        name={name || id}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={autoComplete}
        className={`form-input ${leftIcon ? 'pl-10' : ''} ${rightIcon ? 'pr-10' : ''} ${
          error ? 'border-red-500 focus:border-red-500 focus:ring-red-400' : ''
        }`}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${id}-error` : helperText ? `${id}-help` : undefined}
      />
      {rightIcon && (
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500">
          {rightIcon}
        </div>
      )}
    </div>
    {error && (
      <p id={`${id}-error`} className="mt-1 text-sm text-red-400">
        {error}
      </p>
    )}
    {helperText && !error && (
      <p id={`${id}-help`} className="mt-1 text-sm text-gray-500">
        {helperText}
      </p>
    )}
  </div>
)

FormInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.oneOf(['text', 'email', 'password', 'tel', 'url', 'number']),
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  autoComplete: PropTypes.string,
  error: PropTypes.string,
  helperText: PropTypes.string,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  showRequiredIndicator: PropTypes.bool,
}

export default FormInput
